<template>
    <div class="mb-5">
        <div class="mb-5">
            <div class="email-checkbox__header mb-3">
                {{ $t(item.text) }}
            </div>
            <div class="email-checkbox__text mb-4">
                <span v-html="$t(getLabel(item, 'DESCRIPTION_TEXT').text)"/>
            </div>
            <div>
                <span v-html="$t(getLabel(item, 'LIST').text)"/>
            </div>
        </div>
        <div>
            <div class="email-checkbox__input w-100">
                <div class="email-checkbox__input-label mr-3">
                    {{ $t(`${TEXT_TYPES.INTERACTION_BASE}_INPUT_LABEL_EMAIL`) }}
                </div>
                <div class="w-100">
                    <text-input
                        class="email-checkbox__input-field"
                        :validator="emailValidator"
                        :error-text="$t(`${TEXT_TYPES.INTERACTION_BASE}_INPUT_EMAIL_VALIDATION_ERROR`)"
                        :placeholder="$t(`${TEXT_TYPES.INTERACTION_BASE}_INPUT_PLACEHOLDER_EMAIL`)"
                        @change="value => handleInputChange('email', value)"
                    />
                </div>
            </div>
            <div class="email-checkbox__input w-100">
                <div class="email-checkbox__input-label mr-3">
                    {{ $t(`${TEXT_TYPES.INTERACTION_BASE}_INPUT_LABEL_FIRST_NAME`) }}
                </div>
                <div class="w-100">
                    <text-input
                        class="email-checkbox__input-field"
                        :placeholder="`${$t(`${TEXT_TYPES.INTERACTION_BASE}_INPUT_PLACEHOLDER_FIRST_NAME`)}`"
                        :validator="nameValidator"
                        :error-text="$t(`${TEXT_TYPES.INTERACTION_BASE}_INPUT_FIRST_NAME_VALIDATION_ERROR`)"
                        @change="value => handleInputChange('firstname', value)"
                    />
                </div>
            </div>
            <div class="email-checkbox__input w-100">
                <div class="email-checkbox__input-label mr-3">
                    {{ $t(`${TEXT_TYPES.INTERACTION_BASE}_INPUT_LABEL_LAST_NAME`) }}
                </div>
                <div class="w-100">
                    <text-input
                        class="email-checkbox__input-field"
                        :placeholder="`${$t(`${TEXT_TYPES.INTERACTION_BASE}_INPUT_PLACEHOLDER_LAST_NAME`)}`"
                        :validator="nameValidator"
                        :error-text="$t(`${TEXT_TYPES.INTERACTION_BASE}_INPUT_LAST_NAME_VALIDATION_ERROR`)"
                        @change="value => handleInputChange('lastname', value)"
                    />
                </div>
            </div>
            <div class="email-checkbox__input w-100">
                <div class="email-checkbox__input-label mr-3">
                    {{ $t(`${TEXT_TYPES.INTERACTION_BASE}_INPUT_LABEL_COMPANY`) }}
                </div>
                <div class="w-100">
                    <text-input
                        class="email-checkbox__input-field"
                        :placeholder="`${$t(`${TEXT_TYPES.INTERACTION_BASE}_INPUT_PLACEHOLDER_COMPANY`)}  (${$t(`${TEXT_TYPES.INTERACTION_BASE}_INPUT_OPTIONAL`)})`"
                        @change="value => handleInputChange('company', value)"
                    />
                </div>
            </div>
            <div class="email-checkbox__input w-100">
                <div class="email-checkbox__input-label mr-3">
                    {{ $t(`${TEXT_TYPES.INTERACTION_BASE}_INPUT_LABEL_JOBTITLE`) }}
                </div>
                <div class="w-100">
                    <text-input
                        class="email-checkbox__input-field"
                        :placeholder="`${$t(`${TEXT_TYPES.INTERACTION_BASE}_INPUT_PLACEHOLDER_JOBTITLE`)} (${$t(`${TEXT_TYPES.INTERACTION_BASE}_INPUT_OPTIONAL`)})`"
                        @change="value => handleInputChange('jobtitle', value)"
                    />
                </div>
            </div>
            <div class="email-checkbox__input w-100">
                <div class="email-checkbox__input-label mr-3">
                    {{ $t(`${TEXT_TYPES.INTERACTION_BASE}_INPUT_LABEL_PHONE`) }}
                </div>
                <div class="w-100">
                    <text-input
                        class="email-checkbox__input-field"
                        text-type="phone"
                        :placeholder="`${$t(`${TEXT_TYPES.INTERACTION_BASE}_INPUT_PLACEHOLDER_PHONE`)} (${$t(`${TEXT_TYPES.INTERACTION_BASE}_INPUT_OPTIONAL`)})`"
                        @change="value => handleInputChange('phone', value)"
                    />
                </div>
            </div>
            <b-form-checkbox
                v-model="acceptTOS"
            >
                <span v-html="$t(getLabel(item, 'CHECKBOX_TOS_TEXT').text)"/>
            </b-form-checkbox>
        </div>
    </div>
</template>
<script>
import { getLabel } from '@/utils/items'
import { TEXT_TYPES } from '@/constants/i18n'
import textInput from '@/components/inputs/text'

export default {
    name: 'emailCheckboxItem',
    components: {
        textInput
    },
    props: {
        item: {
            type: Object
        }
    },
    data() {
        return {
            email: null,
            acceptTOS: false,
            firstname: null,
            lastname: null,
            company: null,
            jobtitle: null,
            phone: null,
            TEXT_TYPES
        }
    },
    computed: {
        isValid() {
            return this.email && this.firstname && this.lastname && this.acceptTOS
        }
    },
    watch: {
        acceptTOS() {
            this.validateAnswer()
        }
    },
    methods: {
        getLabel,
        handleInputChange(field, value) {
            this[field] = value

            this.validateAnswer()
        },
        validateAnswer() {
            if(this.isValid) {
                this.handleAnswer()
            } else {
                this.undoAnswer()
            }
        },
        emailValidator(value) {
            const regex = new RegExp(
            /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            );
            return value.match(regex) !== null;
        },
        nameValidator(value) {
            return value.length > 0
        },
        handleAnswer() {
            const data = [
                {
                    key: 'email',
                    value: this.email
                },
                {
                    key: 'acceptTOS',
                    value: this.acceptTOS.toString()
                },
                (this.firstname && {
                    key: 'firstname',
                    value: this.firstname 
                }),
                (this.lastname && {
                    key: 'lastname',
                    value: this.lastname 
                }),
                (this.phone && {
                    key: 'phone',
                    value: this.phone 
                }),
                (this.company && {
                    key: 'company',
                    value: this.company 
                }),
                (this.jobtitle && {
                    key: 'jobtitle',
                    value: this.jobtitle 
                }),
            ].filter(Boolean);

            const answer = {
                result: 1,
                data
            }
            
            this.$emit('answer', answer)
        },
        undoAnswer() {
            this.$emit('answer', null)
        }
    }
}
</script>
<style lang="scss">
.email-checkbox__header {
    font-weight: bold;
    font-size: 1.5rem;
}

.bq-icon-list {
    padding-left: 2rem;
    @media screen and (max-width: 575px) {
        padding-left: 1rem;
    }
}
.bq-icon-list__item {
    background: url("../../assets/ui/check-bullet.svg") no-repeat left top;
    list-style: none;
    margin: 0;
    padding: 0px 0px 0px 10px;
    margin-bottom: 10px;
}

.bq-icon-list__item-content {
    margin-left: 20px;
}

.email-checkbox__input {
    display: flex;
    @media screen and (max-width: 575px) {
        display: block;
    }
}

.email-checkbox__input-label {
    margin-top: 5px;
    min-width: 90px;
    @media screen and (max-width: 575px) {
        display: block;
        margin-top: 0;
        margin-bottom: 8px;
    }
}
</style>
